/* =========================================================================
   SOUNDLABZ — theme.js
   No dependencies. Everything degrades gracefully without JS.
   ========================================================================= */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------------------------------------------------------------- money */
  function money(cents) {
    var fmt = (window.SLZ && window.SLZ.moneyFormat) || '${{amount}}';
    var value = (cents / 100);
    function withCommas(n, decimals) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount': return withCommas(value, 2);
        case 'amount_no_decimals': return withCommas(value, 0);
        case 'amount_with_comma_separator': return withCommas(value, 2).replace(/,/g, ' ').replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0).replace(/,/g, ' ');
        default: return withCommas(value, 2);
      }
    });
  }

  /* ------------------------------------------------------------ page boot */
  function boot() {
    var el = $('.boot');
    if (!el) return;
    var kill = function () {
      el.classList.add('is-done');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 600);
    };
    if (reduced) return kill();
    if (document.readyState === 'complete') setTimeout(kill, 380);
    else window.addEventListener('load', function () { setTimeout(kill, 380); });
    setTimeout(kill, 2600); // safety net
  }

  /* --------------------------------------------------------- scroll reveal */
  function reveals() {
    var items = $$('[data-reveal]');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (n, i) {
      // stagger siblings inside the same parent
      if (!n.style.getPropertyValue('--d')) {
        var sibs = n.parentElement ? Array.prototype.indexOf.call(n.parentElement.children, n) : i;
        n.style.setProperty('--d', Math.min(sibs, 8) * 70 + 'ms');
      }
      io.observe(n);
    });
  }

  /* --------------------------------------------------------- count-up nums */
  function counters() {
    var nodes = $$('[data-count]');
    if (!nodes.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.textContent = n.dataset.prefix || '' ; n.textContent += n.dataset.count + (n.dataset.suffix || ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var n = e.target, target = parseFloat(n.dataset.count), dur = 1400, t0 = null;
        var dec = (n.dataset.count.split('.')[1] || '').length;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = (target * eased).toFixed(dec);
          n.textContent = (n.dataset.prefix || '') + Number(val).toLocaleString(undefined, { minimumFractionDigits: dec }) + (n.dataset.suffix || '');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        io.unobserve(n);
      });
    }, { threshold: 0.5 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* =========================================================================
     THE WAVEFORM — the signature element.
     The logo ring, unrolled into a line. Amplitude tracks scroll velocity,
     so the page literally gets louder the harder you scroll.
     ========================================================================= */
  var Wave = {
    energy: 0,
    lastY: window.pageYOffset,
    instances: [],

    init: function () {
      var canvases = $$('.wave canvas');
      if (!canvases.length) return;

      canvases.forEach(function (cv) {
        var inst = { cv: cv, ctx: cv.getContext('2d'), w: 0, h: 0, seed: Math.random() * 1000 };
        Wave.instances.push(inst);
      });

      Wave.resize();
      window.addEventListener('resize', Wave.resize, { passive: true });

      window.addEventListener('scroll', function () {
        var y = window.pageYOffset;
        var v = Math.min(Math.abs(y - Wave.lastY) / 26, 1);
        Wave.energy = Math.min(Wave.energy + v * 0.55, 1);
        Wave.lastY = y;
        var out = $('[data-spl]');
        if (out) {
          var db = 118 + Math.round(Wave.energy * 34);
          out.textContent = db;
        }
      }, { passive: true });

      if (reduced) { Wave.instances.forEach(Wave.draw.bind(Wave, 0)); return; }
      requestAnimationFrame(Wave.tick);
    },

    resize: function () {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      Wave.instances.forEach(function (i) {
        var r = i.cv.parentElement.getBoundingClientRect();
        i.w = r.width; i.h = r.height;
        i.cv.width = r.width * dpr;
        i.cv.height = r.height * dpr;
        i.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      });
    },

    freq: 0,

    tick: function (ts) {
      // When a tone is playing, real signal takes the wheel from scroll.
      var A = window.SLZAudio;
      if (A && A.isActive()) {
        Wave.energy = Math.max(Wave.energy * 0.7, A.level());
        Wave.freq = A.freq();
        var out = $('[data-spl]');
        if (out) out.textContent = Math.round(Wave.freq);
      } else {
        Wave.energy *= 0.94;             // decay back to idle
        Wave.freq = 0;
      }
      var t = ts / 1000;
      Wave.instances.forEach(function (i) { Wave.draw(t, i); });
      requestAnimationFrame(Wave.tick);
    },

    draw: function (t, i) {
      var ctx = i.ctx, w = i.w, h = i.h;
      if (!w || !h) return;
      ctx.clearRect(0, 0, w, h);

      var mid = h / 2;
      var base = h * 0.12;
      var amp = base + (h * 0.34) * Wave.energy;
      var layers = 3;

      for (var L = 0; L < layers; L++) {
        var grad = ctx.createLinearGradient(0, 0, w, 0);
        grad.addColorStop(0, 'rgba(34,195,238,' + (0.85 - L * 0.26) + ')');
        grad.addColorStop(0.55, 'rgba(0,224,90,' + (0.9 - L * 0.26) + ')');
        grad.addColorStop(1, 'rgba(0,184,74,' + (0.75 - L * 0.24) + ')');

        ctx.beginPath();
        ctx.lineWidth = 2 - L * 0.45;
        ctx.strokeStyle = grad;
        ctx.lineJoin = 'round';

        var phase = t * (0.7 + L * 0.22) + i.seed + L * 0.9;

        // If a tone is playing, draw that tone: low frequencies become long,
        // fat, slow cycles and high ones tighten up. 30Hz should LOOK like 30Hz.
        var tone = Wave.freq > 0;
        var cycles = tone ? Math.max(1.2, Wave.freq / 7) : 0;

        for (var x = 0; x <= w; x += tone ? 2 : 3) {
          var p = x / w;
          // envelope keeps the ends calm so it reads as a signal, not wallpaper
          var env = Math.sin(p * Math.PI);
          var y;
          if (tone) {
            y = mid
              + Math.sin(p * cycles + phase * 3.2) * amp * 0.92 * env
              + Math.sin(p * cycles * 2 + phase * 6.4) * amp * 0.08 * env;
          } else {
            y = mid
              + Math.sin(p * 11 + phase) * amp * 0.55 * env
              + Math.sin(p * 27 - phase * 1.6) * amp * 0.28 * env
              + Math.sin(p * 4.5 + phase * 0.5) * amp * 0.3 * env;
          }
          if (x === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
        }
        ctx.stroke();
      }
    }
  };

  /* ------------------------------------------------------------ the header */
  function header() {
    var head = $('.header');
    if (!head) return;
    var bar = $('.progress');
    var last = 0;

    function onScroll() {
      var y = window.pageYOffset;
      head.classList.toggle('is-stuck', y > 8);
      // hide going down, show going up — but never over the top of the page
      if (y > 320 && y > last + 4) head.classList.add('is-hidden');
      else if (y < last - 4) head.classList.remove('is-hidden');
      last = y;

      if (bar) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? y / max : 0) + ')';
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------- drawer logic */
  var Drawer = {
    open: function (id) {
      var d = document.getElementById(id);
      if (!d) return;
      $$('.drawer.is-open, .search-panel.is-open').forEach(function (n) { if (n !== d) n.classList.remove('is-open'); });
      d.classList.add('is-open');
      $('.scrim').classList.add('is-open');
      document.body.classList.add('is-locked');
      var focusable = d.querySelector('input, button, a');
      if (focusable) setTimeout(function () { focusable.focus(); }, 320);
    },
    closeAll: function () {
      $$('.drawer, .search-panel').forEach(function (n) { n.classList.remove('is-open'); });
      var s = $('.scrim'); if (s) s.classList.remove('is-open');
      document.body.classList.remove('is-locked');
    }
  };

  function drawers() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-open]');
      if (opener) { e.preventDefault(); Drawer.open(opener.dataset.open); return; }
      if (e.target.closest('[data-close]') || e.target.classList.contains('scrim')) {
        Drawer.closeAll();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') Drawer.closeAll();
    });
  }

  /* ================================================================== CART */
  var Cart = {
    render: function (cart) {
      var body = $('#cart-drawer .drawer__body');
      var foot = $('#cart-drawer .drawer__foot');
      if (!body) return;

      $$('[data-cart-count]').forEach(function (n) {
        n.textContent = cart.item_count;
        n.classList.toggle('is-on', cart.item_count > 0);
        n.classList.remove('is-bump');
        void n.offsetWidth;
        if (cart.item_count > 0) n.classList.add('is-bump');
      });

      if (!cart.item_count) {
        body.innerHTML =
          '<div class="cart-empty">' +
          '<svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M2 3h3l2.4 12.2a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L21 7H6"/></svg>' +
          '<p style="font-family:var(--mono);font-size:.78rem;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-3)">Nothing in here yet</p>' +
          '<a class="btn btn--volt" href="/collections/all" style="margin-top:1rem">Start building</a>' +
          '</div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;

      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        return '' +
          '<div class="cart-line" data-key="' + it.key + '">' +
            (img ? '<img class="cart-line__img" src="' + img + '" alt="" loading="lazy">' : '<div class="cart-line__img"></div>') +
            '<div>' +
              '<a class="cart-line__title" href="' + it.url + '">' + it.product_title + '</a>' +
              (variant ? '<div class="cart-line__meta">' + variant + '</div>' : '') +
              '<div class="qty">' +
                '<button type="button" data-qty="-1" aria-label="Reduce quantity">&minus;</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button type="button" data-qty="1" aria-label="Increase quantity">+</button>' +
              '</div>' +
            '</div>' +
            '<div style="text-align:right">' +
              '<div class="cart-line__price">' + money(it.final_line_price) + '</div>' +
              '<button type="button" data-remove style="font-family:var(--mono);font-size:.66rem;letter-spacing:.12em;text-transform:uppercase;color:var(--ink-3);margin-top:.5rem">Remove</button>' +
            '</div>' +
          '</div>';
      }).join('');

      var total = $('[data-cart-total]');
      if (total) total.textContent = money(cart.total_price);
    },

    fetch: function () {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { Cart.render(c); return c; });
    },

    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (c) { Cart.render(c); });
    },

    add: function (form, btn) {
      var data = new FormData(form);
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding&hellip;'; }
      return fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          if (!res.ok) { toast(res.body.description || 'Could not add that item'); return; }
          return Cart.fetch().then(function () {
            Drawer.open('cart-drawer');
          });
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
          toast('Something went wrong. Try again.');
        });
    }
  };

  function cartWiring() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      Cart.add(form, form.querySelector('[data-add]'));
    });

    document.addEventListener('click', function (e) {
      var line = e.target.closest('.cart-line');
      if (!line) return;
      var key = line.dataset.key;
      var q = e.target.closest('[data-qty]');
      if (q) {
        var current = parseInt(line.querySelector('.qty span').textContent, 10);
        Cart.change(key, Math.max(0, current + parseInt(q.dataset.qty, 10)));
      }
      if (e.target.closest('[data-remove]')) Cart.change(key, 0);
    });

    if ($('#cart-drawer')) Cart.fetch();
  }

  /* --------------------------------------------------------------- toast */
  var toastTimer;
  function toast(msg) {
    var t = $('.toast');
    if (!t) return;
    t.querySelector('span').textContent = msg;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  /* --------------------------------------------------- predictive search */
  function search() {
    var input = $('[data-search-input]');
    var out = $('[data-search-results]');
    if (!input || !out) return;
    var timer;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var res = (d.resources && d.resources.results) || {};
            var products = res.products || [];
            var collections = res.collections || [];
            if (!products.length && !collections.length) {
              out.innerHTML = '<p style="padding:1rem;font-family:var(--mono);font-size:.78rem;letter-spacing:.12em;text-transform:uppercase;color:var(--ink-3)">No hits for &ldquo;' + q + '&rdquo;</p>';
              return;
            }
            var html = '';
            if (collections.length) {
              html += '<p class="eyebrow" style="margin:.6rem .7rem">Collections</p>';
              html += collections.slice(0, 3).map(function (c) {
                return '<a href="' + c.url + '"><span></span><span style="font-weight:600">' + c.title + '</span><span></span></a>';
              }).join('');
            }
            if (products.length) {
              html += '<p class="eyebrow" style="margin:1rem .7rem .4rem">Products</p>';
              html += products.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
                return '<a href="' + p.url + '">' +
                  (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
                  '<span><span style="display:block;font-weight:600;font-size:.9rem">' + p.title + '</span>' +
                  '<span style="display:block;font-family:var(--mono);font-size:.7rem;color:var(--ink-3);text-transform:uppercase;letter-spacing:.1em">' + (p.vendor || '') + '</span></span>' +
                  '<span style="font-family:var(--mono);font-weight:600;font-size:.85rem">' + (p.price ? p.price : '') + '</span>' +
                  '</a>';
              }).join('');
            }
            out.innerHTML = html;
          })
          .catch(function () { out.innerHTML = ''; });
      }, 240);
    });
  }

  /* ------------------------------------------------------------ accordion */
  function accordions() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.accordion__btn');
      if (!btn) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
    });
  }

  /* ------------------------------------------------------------ pdp bits */
  function gallery() {
    var g = $('[data-gallery]');
    if (!g) return;
    var main = g.querySelector('[data-gallery-main] img');
    g.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (!t || !main) return;
      $$('[data-thumb]', g).forEach(function (n) { n.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
      main.style.opacity = '0';
      setTimeout(function () {
        main.src = t.dataset.thumb;
        main.srcset = '';
        main.style.opacity = '1';
      }, 140);
    });
  }

  function variants() {
    var root = $('[data-variants]');
    if (!root) return;
    var data;
    try { data = JSON.parse($('[data-variant-json]').textContent); } catch (err) { return; }

    var priceEl = $('[data-price]');
    var compareEl = $('[data-compare]');
    var idInput = $('[data-variant-id]');
    var addBtn = $('[data-add]');
    var stockEl = $('[data-stock]');
    var barPrice = $('[data-bar-price]');
    var financeEl = $('[data-finance-per]');

    root.addEventListener('change', function () {
      var chosen = $$('input:checked', root).map(function (i) { return i.value; });
      var match = data.find(function (v) {
        return v.options.every(function (o, idx) { return o === chosen[idx]; });
      });

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (financeEl) {
        var months = parseInt(financeEl.getAttribute('data-months'), 10) || 12;
        financeEl.textContent = money(Math.round(match.price / months));
      }
      if (barPrice) barPrice.textContent = money(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price);
          compareEl.hidden = false;
        } else compareEl.hidden = true;
      }
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
      if (stockEl) {
        stockEl.classList.toggle('stock--out', !match.available);
        stockEl.querySelector('span').textContent = match.available ? 'In stock — ships today' : 'Out of stock';
      }
      // keep the URL shareable
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
      // swap gallery to the variant image
      var main = $('[data-gallery-main] img');
      if (main && match.featured_image) { main.src = match.featured_image; main.srcset = ''; }
    });

    // labels for the currently selected option
    root.addEventListener('change', function (e) {
      var name = e.target.name;
      var label = root.querySelector('[data-selected="' + name + '"]');
      if (label) label.textContent = e.target.value;
    });
  }

  function buybar() {
    var bar = $('.buybar');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -60% 0px' });
    io.observe(anchor);
  }

  /* --------------------------------------------------- power match widget */
  function matcher() {
    var root = $('[data-matcher]');
    if (!root) return;
    var state = { size: '12', count: '1', ohm: '1' };

    var out = {
      rms: $('[data-out="rms"]', root),
      amp: $('[data-out="amp"]', root),
      wire: $('[data-out="wire"]', root),
      alt: $('[data-out="alt"]', root)
    };

    function calc() {
      var per = { '8': 500, '10': 800, '12': 1200, '15': 1800, '18': 2200 }[state.size] || 1000;
      var total = per * parseInt(state.count, 10);
      var head = Math.round(total * 1.15 / 100) * 100;

      var wire, alt;
      if (total <= 1000) { wire = '4 GA OFC'; alt = 'Stock alt + Big 3'; }
      else if (total <= 2500) { wire = '1/0 GA OFC'; alt = '220A alt or lithium'; }
      else if (total <= 5000) { wire = '1/0 GA OFC x2'; alt = '270A alt + 1 lithium'; }
      else { wire = '1/0 GA OFC x4'; alt = 'Dual alt + 2 lithium'; }

      var draw = Math.round(total / 13.8 / 0.75);

      if (out.rms) out.rms.innerHTML = total.toLocaleString() + 'W<small>RMS at ' + state.ohm + ' ohm</small>';
      if (out.amp) out.amp.innerHTML = head.toLocaleString() + 'W<small>amp, min recommended</small>';
      if (out.wire) out.wire.innerHTML = wire + '<small>power &amp; ground run</small>';
      if (out.alt) out.alt.innerHTML = '~' + draw + 'A<small>' + alt + '</small>';
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-set]');
      if (!b) return;
      var key = b.dataset.set;
      state[key] = b.dataset.value;
      $$('[data-set="' + key + '"]', root).forEach(function (n) {
        n.setAttribute('aria-pressed', String(n === b));
      });
      calc();
    });

    calc();
  }

  /* ---------------------------------------------------------- parallax */
  function parallax() {
    var nodes = $$('[data-parallax]');
    if (!nodes.length || reduced) return;
    var ticking = false;
    function run() {
      nodes.forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var speed = parseFloat(n.dataset.parallax) || 0.12;
        var mid = r.top + r.height / 2 - window.innerHeight / 2;
        n.style.transform = 'translate3d(0,' + (-mid * speed).toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(run); ticking = true; }
    }, { passive: true });
    run();
  }

  /* ------------------------------------------------------ collection sort */
  function sorting() {
    var sel = $('[data-sort]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ------------------------------------------------------------------ go */
  function init() {
    boot();
    header();
    drawers();
    reveals();
    counters();
    Wave.init();
    cartWiring();
    search();
    accordions();
    gallery();
    variants();
    buybar();
    matcher();
    parallax();
    sorting();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Shopify theme editor hooks
  document.addEventListener('shopify:section:load', function () {
    reveals(); counters(); Wave.init(); matcher(); gallery(); variants();
  });

  window.SLZToast = toast;
})();
/* =========================================================
   SOUNDLABZ — HARD 3D MOUSE TILT
   ========================================================= */

(function () {
  'use strict';

  function setup3DCards() {

    var cards = document.querySelectorAll('.card');

    cards.forEach(function (card) {

      if (card.dataset.soundlabzTilt === '1') {
        return;
      }

      card.dataset.soundlabzTilt = '1';

      var frame = null;

      card.addEventListener('pointermove', function (e) {

        if (e.pointerType === 'touch') {
          return;
        }

        var rect = card.getBoundingClientRect();

        var mouseX = e.clientX - rect.left;
        var mouseY = e.clientY - rect.top;

        /*
         * Convert cursor position to -1 → +1
         */

        var x = (mouseX / rect.width) * 2 - 1;
        var y = (mouseY / rect.height) * 2 - 1;

        /*
         * Maximum rotation.
         * Increase these numbers for stronger tilt.
         */

        var rotateY = x * 22;
        var rotateX = y * -22;

        /*
         * Shadow moves opposite direction
         */

        var shadowX = x * -25;
        var shadowY = y * -25 + 25;

        /*
         * Light position
         */

        var lightX = (mouseX / rect.width) * 100;
        var lightY = (mouseY / rect.height) * 100;

        if (frame) {
          cancelAnimationFrame(frame);
        }

        frame = requestAnimationFrame(function () {

          card.style.setProperty(
            '--rx',
            rotateX.toFixed(2) + 'deg'
          );

          card.style.setProperty(
            '--ry',
            rotateY.toFixed(2) + 'deg'
          );

          card.style.setProperty(
            '--tz',
            '22px'
          );

          card.style.setProperty(
            '--sx',
            shadowX.toFixed(2) + 'px'
          );

          card.style.setProperty(
            '--sy',
            shadowY.toFixed(2) + 'px'
          );

          card.style.setProperty(
            '--light-x',
            lightX.toFixed(1) + '%'
          );

          card.style.setProperty(
            '--light-y',
            lightY.toFixed(1) + '%'
          );

        });

      }, { passive: true });


      card.addEventListener('pointerenter', function () {

        card.classList.add('card-tilting');

        card.style.transition =
          'transform .08s linear, box-shadow .15s ease';

      });


      card.addEventListener('pointerleave', function () {

        card.classList.remove('card-tilting');

        if (frame) {
          cancelAnimationFrame(frame);
        }

        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--tz', '0px');

        card.style.setProperty('--sx', '0px');
        card.style.setProperty('--sy', '25px');

        card.style.setProperty('--light-x', '50%');
        card.style.setProperty('--light-y', '50%');

        card.style.transition =
          'transform .55s cubic-bezier(.2,.8,.2,1), box-shadow .4s ease';

      });

    });
  }


  /*
   * Initial setup
   */

  function start() {
    setup3DCards();

    /*
     * Shopify can dynamically render products.
     */
    var observer = new MutationObserver(function () {
      setup3DCards();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      start
    );

  } else {

    start();

  }

})();
/* ============================================================
   SOUNDLABZ — 3D ADD TO CART
   REAL SHOPIFY CART UPDATE
   ONE SINGLE CART HANDLER
============================================================ */

(function () {
  'use strict';

  var animating = false;

  /* =========================================================
     FIND PRODUCT FORM
  ========================================================= */

  function getProductForm(button) {
    if (!button) return null;

    var form = null;

    var formId = button.getAttribute('form');

    if (formId) {
      form = document.getElementById(formId);
    }

    if (!form) {
      form = button.closest(
        'form.shopify-product-form, form[action*="/cart/add"]'
      );
    }

    if (!form) {
      form = document.querySelector(
        'form.shopify-product-form[action*="/cart/add"],' +
        'form[action*="/cart/add"]'
      );
    }

    return form;
  }


  /* =========================================================
     FIND PRODUCT IMAGE
  ========================================================= */

  function getProductImage(form) {
    if (!form) return null;

    var card = form.closest('.card');

    if (card) {
      return (
        card.querySelector('.card__media img.card__main') ||
        card.querySelector('.card__media img') ||
        card.querySelector('img')
      );
    }

    var selectors = [
      '[data-gallery-main] img',
      '.product__media img',
      '.product-media img',
      '.product-gallery img',
      '.product__image img',
      '.product-single__media img',
      '.product__media-item img',
      '.product-gallery__image img',
      '.product img'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var img = document.querySelector(selectors[i]);

      if (!img) continue;

      var rect = img.getBoundingClientRect();

      if (rect.width > 30 && rect.height > 30) {
        return img;
      }
    }

    return null;
  }


  /* =========================================================
     FIND CART ICON
  ========================================================= */

  function findCart() {
    var selectors = [
      '.header__cart',
      '.header__cart-link',
      '.header-cart',
      '.cart-icon',
      '.cart-link',

      '.mobile-header__cart',
      '.mobile-cart',
      '.mobile-nav__cart',

      '[data-cart-toggle]',
      '[data-cart-drawer-toggle]',
      '[data-cart-icon]',

      'button[name="cart"]',
      'button[aria-label*="cart" i]',
      'button[aria-label*="bag" i]',

      'a[href="/cart"]',
      'a[href$="/cart"]'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var elements = document.querySelectorAll(selectors[i]);

      for (var j = 0; j < elements.length; j++) {
        var el = elements[j];
        var rect = el.getBoundingClientRect();

        if (
          rect.width > 0 &&
          rect.height > 0 &&
          rect.top >= 0 &&
          rect.left >= 0
        ) {
          return el;
        }
      }
    }

    return null;
  }


  /* =========================================================
     UPDATE CART NUMBER
  ========================================================= */

  function updateCartCount(cart) {
    if (!cart) return;

    var selectors = [
      '[data-cart-count]',
      '[data-cart-count-bubble]',
      '.cart-count',
      '.cart__count',
      '.cart-count-bubble',
      '.header__cart-count',
      '.cart-link__count',
      '.cart-item-count'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.textContent = cart.item_count;

        if (cart.item_count > 0) {
          el.classList.add('is-on');
        } else {
          el.classList.remove('is-on');
        }
      });
    });
  }


  /* =========================================================
     UPDATE OUR CART DRAWER
     YOUR THEME USES #cart-drawer
  ========================================================= */

  function updateOurCartDrawer(cart) {
    if (
      window.SLZ &&
      window.SLZ.Cart &&
      typeof window.SLZ.Cart.render === 'function'
    ) {
      window.SLZ.Cart.render(cart);
      return;
    }

    /*
     * Your theme.js Cart object is inside its IIFE,
     * so we update the drawer directly here.
     */

    var body = document.querySelector(
      '#cart-drawer .drawer__body'
    );

    var foot = document.querySelector(
      '#cart-drawer .drawer__foot'
    );

    if (!body) return;

    if (!cart.item_count) {

      body.innerHTML =
        '<div class="cart-empty">' +
          '<svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4">' +
            '<circle cx="9" cy="20" r="1.5"/>' +
            '<circle cx="18" cy="20" r="1.5"/>' +
            '<path d="M2 3h3l2.4 12.2a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L21 7H6"/>' +
          '</svg>' +
          '<p style="font-family:var(--mono);font-size:.78rem;letter-spacing:.14em;text-transform:uppercase;color:var(--ink-3)">' +
            'Nothing in here yet' +
          '</p>' +
          '<a class="btn btn--volt" href="/collections/all" style="margin-top:1rem">' +
            'Start building' +
          '</a>' +
        '</div>';

      if (foot) foot.hidden = true;

      return;
    }

    if (foot) foot.hidden = false;

    function formatMoney(cents) {
      var format =
        window.SLZ &&
        window.SLZ.moneyFormat
          ? window.SLZ.moneyFormat
          : '${{amount}}';

      var amount = (cents / 100).toFixed(2);

      return format
        .replace('{{amount}}', amount)
        .replace('{{ amount }}', amount);
    }

    body.innerHTML = cart.items.map(function (item) {

      var image = item.image || '';

      var variant =
        item.variant_title &&
        item.variant_title !== 'Default Title'
          ? item.variant_title
          : '';

      return (
        '<div class="cart-line" data-key="' + item.key + '">' +

          (
            image
              ? '<img class="cart-line__img" src="' +
                image +
                '" alt="" loading="lazy">'
              : '<div class="cart-line__img"></div>'
          ) +

          '<div>' +

            '<a class="cart-line__title" href="' +
              item.url +
            '">' +
              item.product_title +
            '</a>' +

            (
              variant
                ? '<div class="cart-line__meta">' +
                    variant +
                  '</div>'
                : ''
            ) +

            '<div class="qty">' +

              '<button type="button" data-qty="-1" aria-label="Reduce quantity">' +
                '&minus;' +
              '</button>' +

              '<span>' +
                item.quantity +
              '</span>' +

              '<button type="button" data-qty="1" aria-label="Increase quantity">' +
                '+' +
              '</button>' +

            '</div>' +

          '</div>' +

          '<div style="text-align:right">' +

            '<div class="cart-line__price">' +
              formatMoney(item.final_line_price) +
            '</div>' +

            '<button type="button" data-remove style="font-family:var(--mono);font-size:.66rem;letter-spacing:.12em;text-transform:uppercase;color:var(--ink-3);margin-top:.5rem">' +
              'Remove' +
            '</button>' +

          '</div>' +

        '</div>'
      );

    }).join('');

    var total = document.querySelector(
      '[data-cart-total]'
    );

    if (total) {
      total.textContent = formatMoney(
        cart.total_price
      );
    }
  }


  /* =========================================================
     GET REAL CART FROM SHOPIFY
  ========================================================= */

  function getCart() {
    return fetch(
      (window.Shopify &&
       window.Shopify.routes &&
       window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/') +
      'cart.js?timestamp=' +
      Date.now(),
      {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: {
          'Accept': 'application/json'
        }
      }
    )
    .then(function (response) {

      if (!response.ok) {
        throw new Error(
          'Could not load Shopify cart'
        );
      }

      return response.json();
    });
  }


  /* =========================================================
     ADD PRODUCT TO SHOPIFY
  ========================================================= */

  function addProduct(form) {

    var formData = new FormData(form);

    if (!formData.get('quantity')) {
      formData.set('quantity', '1');
    }

    return fetch(
      (window.Shopify &&
       window.Shopify.routes &&
       window.Shopify.routes.cart_add_url)
        ? window.Shopify.routes.cart_add_url
        : '/cart/add.js',
      {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      }
    )
    .then(function (response) {

      return response.json()
        .then(function (data) {

          if (!response.ok) {
            throw new Error(
              data.description ||
              'Could not add product to cart.'
            );
          }

          return data;
        });
    });
  }


  /* =========================================================
   SOUNDLABZ — FAST FLYING PRODUCT → CART
========================================================= */

function flyToCart(image, cart) {

  if (!image || !cart) {
    console.warn('[SoundLabz] Fly animation: image/cart missing');
    return;
  }

  var start = image.getBoundingClientRect();
  var end = cart.getBoundingClientRect();

  if (start.width < 5 || start.height < 5 ||
      end.width < 5 || end.height < 5) {
    console.warn('[SoundLabz] Fly animation: invalid positions');
    return;
  }

  /* -----------------------------------------
     CREATE CLONE
  ----------------------------------------- */

  var clone = image.cloneNode(true);

  clone.className = 'sl-fly-product';

  Object.assign(clone.style, {
    position: 'fixed',
    zIndex: '2147483647',
    pointerEvents: 'none',

    left: (start.left + start.width / 2 - 55) + 'px',
    top: (start.top + start.height / 2 - 55) + 'px',

    width: '110px',
    height: '110px',

    margin: '0',
    padding: '0',

    objectFit: 'contain',

    display: 'block',
    visibility: 'visible',
    opacity: '1',

    transformOrigin: 'center center',

    transform:
      'translate3d(0,0,0) ' +
      'scale(1) ' +
      'rotate(0deg)',

    transition: 'none'
  });

  document.body.appendChild(clone);

  /* Force browser to render starting position */
  clone.getBoundingClientRect();

  /* -----------------------------------------
     TARGET
  ----------------------------------------- */

  var targetX =
    end.left + end.width / 2 - 22;

  var targetY =
    end.top + end.height / 2 - 22;

  /* -----------------------------------------
     FAST FLIGHT
  ----------------------------------------- */

  requestAnimationFrame(function () {

    clone.style.transition =
      'left 480ms cubic-bezier(.22,1,.36,1), ' +
      'top 480ms cubic-bezier(.22,1,.36,1), ' +
      'width 480ms cubic-bezier(.22,1,.36,1), ' +
      'height 480ms cubic-bezier(.22,1,.36,1), ' +
      'transform 480ms cubic-bezier(.22,1,.36,1), ' +
      'opacity 480ms ease';

    clone.style.left = targetX + 'px';
    clone.style.top = targetY + 'px';

    clone.style.width = '44px';
    clone.style.height = '44px';

    clone.style.transform =
      'translate3d(0,0,0) ' +
      'scale(.35) ' +
      'rotate(360deg)';

    clone.style.opacity = '0.15';

  });

  /* -----------------------------------------
     CART IMPACT
  ----------------------------------------- */

  setTimeout(function () {

    if (clone.parentNode) {
      clone.parentNode.removeChild(clone);
    }

    cart.classList.remove('cart-shake');

    void cart.offsetWidth;

    cart.classList.add('cart-shake');

    setTimeout(function () {
      cart.classList.remove('cart-shake');
    }, 450);

  }, 500);
}

  /* =========================================================
     MAIN ADD TO CART HANDLER
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var button =
        event.target.closest(
          [
            'form.shopify-product-form button[type="submit"]',
            'form[action*="/cart/add"] button[type="submit"]',
            'button[name="add"]',
            '[type="submit"][name="add"]',
            '.product-form__submit',
            '.buybar button[type="submit"]',
            '.buybar button[data-add]',
            '[data-buy-add]'
          ].join(',')
        );

      if (!button) return;

      var form =
        getProductForm(button);

      if (!form) return;

      /*
       * THIS IS THE ONLY ADD-TO-CART HANDLER.
       */

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (animating) return;

      animating = true;

      var image =
        getProductImage(form);

      var cart =
        findCart();

      /*
       * ADD TO SHOPIFY FIRST.
       */

      addProduct(form)

        .then(function () {

          /*
           * NOW Shopify definitely has
           * the product.
           */

          return getCart();

        })

        .then(function (cartData) {

          /*
           * Update cart number immediately.
           */

          updateCartCount(
            cartData
          );

          /*
           * Update YOUR custom drawer
           * immediately.
           */

          updateOurCartDrawer(
            cartData
          );

          /*
           * Fire events so any other
           * Shopify/theme code can react.
           */

          document.dispatchEvent(
            new CustomEvent(
              'cart:updated',
              {
                detail: {
                  cart: cartData
                }
              }
            )
          );

          document.dispatchEvent(
            new CustomEvent(
              'cart:update',
              {
                detail: {
                  cart: cartData
                }
              }
            )
          );

          /*
           * FLYING PRODUCT.
           */

          if (cart) {
            flyToCart(
              image,
              cart
            );
          }

        })

        .catch(function (error) {

          console.error(
            '[SoundLabz] Add to cart failed:',
            error
          );

          if (
            window.SLZToast
          ) {
            window.SLZToast(
              error.message ||
              'Could not add product.'
            );
          }

        })

        .finally(function () {

          setTimeout(function () {
            animating = false;
          }, 1500);

        });

    },
    true
  );


  /* =========================================================
     STOP NORMAL PRODUCT FORM SUBMISSION
     ONLY WHILE OUR HANDLER IS RUNNING
  ========================================================= */

  document.addEventListener(
    'submit',
    function (event) {

      var form =
        event.target;

      if (!form) return;

      if (
        !form.matches(
          'form.shopify-product-form,' +
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }

      if (animating) {

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

      }

    },
    true
  );


  /* =========================================================
     CART QUANTITY / REMOVE
  ========================================================= */

  document.addEventListener(
    'click',
    function (event) {

      var line =
        event.target.closest(
          '.cart-line'
        );

      if (!line) return;

      var key =
        line.dataset.key;

      var qtyButton =
        event.target.closest(
          '[data-qty]'
        );

      var removeButton =
        event.target.closest(
          '[data-remove]'
        );

      if (!qtyButton && !removeButton) {
        return;
      }

      event.preventDefault();

      var current =
        parseInt(
          line.querySelector(
            '.qty span'
          ).textContent,
          10
        );

      var quantity;

      if (removeButton) {
        quantity = 0;
      } else {
        quantity =
          Math.max(
            0,
            current +
            parseInt(
              qtyButton.dataset.qty,
              10
            )
          );
      }

      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type':
            'application/json',
          'Accept':
            'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cartData) {

        updateCartCount(
          cartData
        );

        updateOurCartDrawer(
          cartData
        );

      });

    }
  );

})();
/* =========================================================
   SOUNDLABZ — PRODUCT CARD BUTTON → PRODUCT PAGE
   Product cards ONLY
   ========================================================= */

(function () {
  function convertProductCardButtons() {
    document.querySelectorAll(".card").forEach(function (card) {
      const form = card.querySelector(".card__quick form");
      const button = card.querySelector(".card__quick button[type='submit']");
      const productLink = card.querySelector(".card__title a");

      if (!form || !button || !productLink) return;

      // Already converted
      if (button.dataset.productRedirect === "true") return;

      button.dataset.productRedirect = "true";

      // Create a normal link using the exact same button appearance
      const link = document.createElement("a");

      // Copy all button classes
      link.className = button.className;

      // Copy useful visual attributes
      link.style.cssText = button.style.cssText;

      link.href = productLink.href;
      link.textContent = button.textContent.trim() || "Add to cart";

      // Prevent anything from treating this as an Add-to-Cart button
      link.removeAttribute("data-add");
      link.removeAttribute("type");
      link.setAttribute("data-product-redirect", "true");

      // Replace the actual submit button
      button.replaceWith(link);

      // Disable the card form itself
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }, true);
    });
  }

  // Initial cards
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", convertProductCardButtons);
  } else {
    convertProductCardButtons();
  }

  // Shopify can dynamically render/re-render product cards
  const observer = new MutationObserver(function () {
    convertProductCardButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
/* =========================================================
   SOUNDLABZ — CATEGORY CARD INTERACTION
   INSTANT PARALLAX
   ========================================================= */

(function () {

  "use strict";


  function initSoundLabzCategoryCards() {

    const cards =
      document.querySelectorAll(".rack__tile");


    cards.forEach(function (card) {

      /* Don't initialize twice */

      if (card.dataset.slReady === "true") {
        return;
      }

      card.dataset.slReady = "true";


      /* ---------------------------------------------------
         CREATE CURSOR LIGHT
         --------------------------------------------------- */

      const light =
        document.createElement("div");

      light.className =
        "sl-category-light";

      card.appendChild(light);


      /* ---------------------------------------------------
         ENTER
         --------------------------------------------------- */

      card.addEventListener(
        "pointerenter",
        function (event) {

          const rect =
            card.getBoundingClientRect();


          const x =
            (event.clientX - rect.left) /
            rect.width;


          const y =
            (event.clientY - rect.top) /
            rect.height;


          const mx =
            (x - 0.5) * 2;


          const my =
            (y - 0.5) * 2;


          /*
           * IMPORTANT:
           *
           * Set position BEFORE hover
           * animation has time to move.
           */

          card.style.setProperty(
            "--sl-x",
            mx
          );

          card.style.setProperty(
            "--sl-y",
            my
          );

        },
        { passive: true }
      );


      /* ---------------------------------------------------
         MOVE
         --------------------------------------------------- */

      card.addEventListener(
        "pointermove",
        function (event) {

          const rect =
            card.getBoundingClientRect();


          const x =
            (event.clientX - rect.left) /
            rect.width;


          const y =
            (event.clientY - rect.top) /
            rect.height;


          const mx =
            (x - 0.5) * 2;


          const my =
            (y - 0.5) * 2;


          /*
           * Directly update CSS variables.
           *
           * There is NO JS animation loop
           * and NO transform transition.
           */

          card.style.setProperty(
            "--sl-x",
            mx
          );

          card.style.setProperty(
            "--sl-y",
            my
          );

        },
        { passive: true }
      );


      /* ---------------------------------------------------
         LEAVE
         --------------------------------------------------- */

      card.addEventListener(
        "pointerleave",
        function () {

          card.style.setProperty(
            "--sl-x",
            "0"
          );

          card.style.setProperty(
            "--sl-y",
            "0"
          );

        }
      );

    });

  }


  /* -------------------------------------------------------
     INITIALIZE
     ------------------------------------------------------- */

  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initSoundLabzCategoryCards
    );

  } else {

    initSoundLabzCategoryCards();

  }


  /* -------------------------------------------------------
     SHOPIFY / DYNAMIC CONTENT
     ------------------------------------------------------- */

  const observer =
    new MutationObserver(
      function () {

        initSoundLabzCategoryCards();

      }
    );


  observer.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );


})();
/* =========================================================
   SOUNDLABZ — CURSOR ENERGY TRAIL
   Small signal particles following the cursor
   ========================================================= */

(function () {

  'use strict';

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    window.matchMedia('(pointer: coarse)').matches ||
    window.innerWidth <= 900
  ) {
    return;
  }

  var dots = [];
  var mouseX = -100;
  var mouseY = -100;
  var lastX = mouseX;
  var lastY = mouseY;
  var speed = 0;
  var active = false;

  /* -------------------------------------------------------
     CREATE TRAIL
     ------------------------------------------------------- */

  for (var i = 0; i < 4; i++) {

    var dot = document.createElement('div');

    dot.className = 'sl-cursor-trail';

    document.body.appendChild(dot);

    dots.push({
      el: dot,
      x: mouseX,
      y: mouseY,
      delay: i * 0.16
    });

  }


  /* -------------------------------------------------------
     MOUSE
     ------------------------------------------------------- */

  document.addEventListener('mousemove', function (e) {

    mouseX = e.clientX;
    mouseY = e.clientY;

    var dx = mouseX - lastX;
    var dy = mouseY - lastY;

    speed = Math.sqrt(dx * dx + dy * dy);

    lastX = mouseX;
    lastY = mouseY;

    active = true;

  }, { passive: true });


  /* -------------------------------------------------------
     HIDE WHEN LEAVING WINDOW
     ------------------------------------------------------- */

  document.addEventListener('mouseleave', function () {

    active = false;

    dots.forEach(function (dot) {
      dot.el.style.opacity = '0';
    });

  });

  document.addEventListener('mouseenter', function () {
    active = true;
  });


  /* -------------------------------------------------------
     ANIMATION
     ------------------------------------------------------- */

  function animate() {

    var previousX = mouseX;
    var previousY = mouseY;

    dots.forEach(function (dot, index) {

      /*
       * First dot follows cursor.
       * Each following dot follows the previous dot.
       */

      var targetX =
        index === 0
          ? mouseX
          : dots[index - 1].x;

      var targetY =
        index === 0
          ? mouseY
          : dots[index - 1].y;


      /*
       * Smooth signal movement.
       */

      dot.x += (targetX - dot.x) * 0.24;
      dot.y += (targetY - dot.y) * 0.24;


      dot.el.style.left = dot.x + 'px';
      dot.el.style.top = dot.y + 'px';


      /*
       * Faster movement = stronger signal.
       */

      var fast =
        Math.min(speed / 35, 1);


      if (active) {

        var baseOpacity =
          index === 0
            ? 0.85
            : Math.max(
                0.08,
                0.58 - index * 0.15
              );

        dot.el.style.opacity =
          baseOpacity * Math.min(
            1,
            0.35 + fast
          );

      }


      /*
       * First particle expands
       * when cursor moves quickly.
       */

      if (index === 0) {

        dot.el.classList.toggle(
          'is-fast',
          speed > 18
        );

      }

    });


    /*
     * Speed naturally decays.
     */

    speed *= 0.88;

    requestAnimationFrame(animate);

  }


  animate();

})();
/* =========================================================
   MOBILE — REVEAL EVERY TIME
   Blur -> clear when entering viewport
   Clear -> blur when leaving viewport
   No movement
   ========================================================= */

(function () {

  if (window.innerWidth > 991) return;

  function initMobileReveal() {

    var items = document.querySelectorAll('[data-reveal]');

    if (!items.length) return;

    /*
     * IMPORTANT:
     * We use a NEW observer here.
     *
     * Unlike the desktop observer, we DO NOT unobserve
     * elements after revealing them.
     */

    var observer = new IntersectionObserver(function (entries) {

      entries.forEach(function (entry) {

        if (entry.isIntersecting) {

          /*
           * ENTERING viewport
           */
          entry.target.classList.add('is-in');

        } else {

          /*
           * LEAVING viewport
           *
           * Remove the class so it becomes blurred again.
           */
          entry.target.classList.remove('is-in');

        }

      });

    }, {

      /*
       * Trigger when a small part of the section
       * enters the viewport.
       */
      threshold: 0.05,

      /*
       * Give the reveal a little breathing room.
       */
      rootMargin: '0px 0px -5% 0px'

    });


    items.forEach(function (el) {

      /*
       * Make sure the desktop animation's movement
       * is completely disabled on mobile.
       */
      el.style.setProperty(
        'transform',
        'none',
        'important'
      );

      observer.observe(el);

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initMobileReveal
    );

  } else {

    initMobileReveal();

  }

})();
